import React from 'react';
import Panel from './shared/Panel';
import FeaturedDapps from './containers/FeaturedDapps';
import DappCatalog from './containers/DappCatalog';

export default () => (
	<Panel title="DAPP CATALOG" description="">
		<DappCatalog />
	</Panel>
);